import React from "react";
import PropTypes from "prop-types";
import OneCol, { Row } from "layouts/OneCol";
import Header from "components/views/Header";
import T from "i18n";
import PageHeading from "components/views/atoms/PageHeading";
import ProductsHeading from "components/views/atoms/ProductsHeading";
import ResultsHeading from "components/views/ResultsHeading";
import EndOfPageNotes from "components/views/EndOfPageNotes";
import OutlinedMoreHelp from "components/views/OutlinedMoreHelp";
import OutlinedLinksGrid from "components/views/OutlinedLinksGrid";
import TopProduct from "components/containers/TopRecommendedProduct";
import OtherProducts from "components/containers/OtherRecommendedProducts";
import Footer from "components/views/atoms/Footer";
import ResultsPageTracker from "components/utils/ResultsPageTracker";

const Results = ({ className, breadcrumbs }) => {
  const classes = ["Results"];
  if (className) classes.push(className);
  const bc = breadcrumbs.map((b) => b());  
  return (
    <OneCol className={classes.join(" ")}>
      <Header heading="Commercial" />
      <PageHeading>
        <T path="common.productSelector" />
      </PageHeading>

      <Row fullWidth>
        <ResultsHeading breadcrumbSteps={bc} />
      </Row>

      <ProductsHeading heading={(<T path="resultsPage.heading" />)} buttonText={(<T path="resultsPage.buyButtonText" />)} buttonLink={T({ path: "resultsPage.buyButtonLink" })} />       

      <Row bgColor="azure" style={{ position: `relative` }}>
        <TopProduct />
      </Row>

      <Row>
        <OtherProducts />
      </Row>

      <Row>
        <OutlinedLinksGrid>
          <OutlinedMoreHelp LinkLabel={T({ path: "button.moreHelpUrl" })} />
        </OutlinedLinksGrid>
      </Row>

      <Row>
        <EndOfPageNotes />
      </Row>

      <ResultsPageTracker />

      <Footer />
    </OneCol>
  );
};

Results.displayName = "Results";

Results.propTypes = {
  className: PropTypes.string,
  breadcrumbs: PropTypes.arrayOf(PropTypes.func),
};

Results.defaultProps = {
  className: null,
  breadcrumbs: [],
};

export default Results;
